import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GridContainer } from '~/components/GridContainer';
import { EmptyState } from '~/components/empty-state';
import TvBrandsIllustration from '~/images/illustrations/tv-brands.svg';
import type { LiveChannels__Channel as Channel } from '../queries/list.generated';
import { ChannelCard } from './ChannelCard';

export interface ChannelGridProps {
  channels: readonly Channel[];
  loading?: boolean;
}

export const ChannelGrid = ({ channels, loading }: ChannelGridProps) => {
  const { t } = useTranslation();

  return (
    <GridContainer
      loading={loading}
      isEmpty={channels.length === 0}
      emptyState={
        <EmptyState
          illustration={TvBrandsIllustration}
          header={t('pages.live_channels.empty_state.header')}
          description={t('pages.live_channels.empty_state.description')}
        />
      }
    >
      <Grid container spacing={2}>
        {channels.map((channel) => (
          <Grid item xs={12} sm={6} md={3} lg={2} key={channel.id}>
            <ChannelCard channel={channel} />
          </Grid>
        ))}
      </Grid>
    </GridContainer>
  );
};
